import { render } from "./IconsAlerts.vue?vue&type=template&id=8cc75162"
import script from "./IconsAlerts.vue?vue&type=script&lang=js"
export * from "./IconsAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__